import styled from 'styled-components';

// Modal bloqueante sin header (sin botón X). Mismo layout y mismos tokens que
// `GpsRequiredModal`, que es el hermano canónico: las dos son la misma
// situación —falta un permiso y no se puede seguir— y deben verse igual.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.l}rem;
  padding: ${({ theme }) => theme.spaces.xl}rem;
  background: ${({ theme }) => theme.colors.white};
  /* Tokens canónicos de ModalContainer (auditoría modales 2026-07-06):
     mismo radius y sombra que el resto de modales de la app. */
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.modal};
  min-width: 28rem;
  max-width: 40rem;
  text-align: center;

  /* Portrait tablet: padding más compacto + ancho casi total para que el
     mensaje no se sienta perdido en pantalla pequeña. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
    padding: ${({ theme }) => theme.spaces.l}rem;
    min-width: 0;
    width: calc(100vw - 4rem);
    max-width: 32rem;
  }
`;

export const IconImg = styled.img`
  width: 4rem;
  height: 4rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 3rem;
    height: 3rem;
  }
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

/**
 * La etiqueta exacta que el operario tiene que buscar en Ajustes. Va aparte y
 * destacada a propósito: dentro del párrafo se pierde, y es justo la palabra
 * que va a ir buscando con el dedo por una pantalla que no conoce.
 */
export const OptionChip = styled.strong`
  font-family: 'Poppins', sans-serif;
  font-size: ${({ theme }) => theme.fontSize.M};
  padding: ${({ theme }) => theme.spaces.xs}rem
    ${({ theme }) => theme.spaces.m}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.garnetClear};
  color: ${({ theme }) => theme.colors.garnet};
`;
